import { createSlice } from '@reduxjs/toolkit';
import { resetAdminPersistedJourneyState } from 'store/adminJourneyReset';

import {
  applySessionTokenPayload,
  createEmptySessionTokensState,
  type SessionTokenPayload,
  type SessionTokensState,
} from './sessionTokensSliceShared';

export type AdminSessionState = SessionTokensState;

const initialState = createEmptySessionTokensState();

const adminSessionSlice = createSlice({
  name: 'adminSession',
  initialState,
  reducers: {
    setAdminSessionTokens(state, action: { payload: SessionTokenPayload }) {
      applySessionTokenPayload(state, action.payload);
    },
    clearAdminSession: () => createEmptySessionTokensState(),
  },
  extraReducers: builder => {
    builder.addCase(resetAdminPersistedJourneyState, () => createEmptySessionTokensState());
  },
});

export const { setAdminSessionTokens, clearAdminSession } = adminSessionSlice.actions;
export default adminSessionSlice.reducer;
